import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import '../Scroll/Scroll.css';

const ScrollSection = () => {
  useEffect(() => {
    // GSAP animation for rotating and scaling letters
    const letters = document.querySelectorAll('.scroll-text span');
    
    gsap.fromTo(
      letters,
      { rotation: 180, scale: 0.3 }, // Start with rotation and scaled down
      {
        rotation: 0, // End with no rotation
        scale: 1, // Scale to normal size
        stagger: 0.2, // Stagger each letter's animation
        repeat: -1, 
        yoyo: true, // Reverse the animation after it completes
        duration: 0.8, // Duration for smoothness
        ease: 'power4.out', // Smooth easing effect
      }
    );
  }, []);

  return (
    <div className="scroll-section">
      <h1 className="scroll-text">
        {['W', 'E', '', 'C', 'A', 'R', 'E', ' ', ' N', 'U', 'M', 'B', 'E', 'R', 'S'].map((letter, index) => (
          <span key={index}>{letter}</span>
        ))}
      </h1>
    </div>
  );
};

export default ScrollSection;
